import React, { useContext, useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContextProvider";

function LoginWithGoogle() {
  const [isLoading, setIsLoading] = useState(false);
  const { setAuthAndPersist, setLoginUserAndPersist } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLoginSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const userData = {
        googleId: decoded.sub,
        email_id: decoded.email,
      };

      // Send user data to the backend
      const response = await fetch(
        "https://domains-marketplace-backend.vercel.app/sam/doc/users/google-login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );

      if (response.ok) {
        const result = await response.json(); // Read the response once

        if (result.user) {
          // Save JWT token if provided by backend
          if (result.token) {
            localStorage.setItem("token", result.token);
          }

          // Login successful
          setAuthAndPersist(true);
          setLoginUserAndPersist(result.user);
          navigate("/Dashboard/Profile");
          const username = result.user.username || "User";
          toast.success(`Welcome back, ${username}`);
        } else {
          // Handle case where no user exists but response was OK
          toast.error(
            result.message || "User does not exist. Please create an account."
          );
        }
      } else {
        // Handle non-200 responses (e.g., 404, 500)
        const errorResult = await response.json(); // Read error response
        toast.error(errorResult.message || "An error occurred during login.");
      }
    } catch (error) {
      toast.error(`Login failed: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <GoogleOAuthProvider clientId="363641818437-hhrq97hkl5dikvnmsb5e2u3u67of6rru.apps.googleusercontent.com">
        {!isLoading ? (
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={() => {
              toast.error("Login Failed");
            }}
            width="100%"
            size="large"
            text="signin_with"
            logo_alignment="center"
          />
        ) : (
          <p className="items-center flex gap-[8px] w-full justify-center">
            <span className="loading loading-spinner loading-sm"></span> Logging
            in...
          </p>
        )}
      </GoogleOAuthProvider>
      <br />
    </div>
  );
}

export default LoginWithGoogle;
